<template>
  <div class="wrapper__profile">

    <!--    <h1 @click="clickButton('12345')">TEXT</h1>-->
    <!--    <div class="profile__notification-tables" v-if="notificationState">-->
    <!--      <div v-if="notificationLoader === false" class="profile__notification-loader">-->
    <!--        <Loader/>-->
    <!--      </div>-->

    <!--      <div v-for="(elem,index) in notificationData" :key="index" class="profile__notification-elem">-->
    <!--        <template>-->
    <!--          <div class="profile__notification-image">-->
    <!--            <img :src="getImagePath(elem.logo)" alt="Logo">-->
    <!--          </div>-->
    <!--          <p class="profile__notification-record">You record event<br/> {{ elem.translations[0].name }}<br/>-->
    <!--            {{ elem.translations[1].name }}</p>-->
    <!--        </template>-->


    <!--      </div>-->

    <!--    </div>-->
    <!--    <div class="profile__notification" @click="toggleNotification()">-->
    <!--      <span class="profile__notification-text">N</span>-->
    <!--      <img src="@/assets/header/notification.svg" alt="Notification">-->
    <!--    </div>-->

    <router-link class="profile" :to="$i18nRoute({ name: 'profile' })">
      <!--      <div class="profile__avatar">-->
      <!--        <img :src="`${publicPath}img/header/avatar@2x.png`" alt="Avatar">-->
      <!--      </div>-->

      <span class="profile__name">{{ user.firstName }} {{ user.lastName }}</span>

      <!--      <img class="profile__arrow" src="@/assets/layouts/icons/arrow.svg" alt="Arrow">-->
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { LoadEvents } from '@/controllers/LoadEvents'

import Loader from '@/components/Global/Loader'

export default {

  name: 'Profile',
  components: {},
  created () {
    // this.$socket.on('msgToClient', (message) => {
    //   this.receivedMessage(message)
    //   alert(1)
    // })
    // this.sockets.subscribe('msgToClient', (data) => {
    //   this.msg = data.message;
    //   this.receivedMessage(data)
    // });
  },
  // sockets: {
  //   connect: function () {
  //     console.log('socket connected')
  //   },
  //   customEmit: function (data) {
  //     console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
  //   }
  // },
  mounted () {

  },

  data () {
    return {
      title: 'Nestjs Websockets Chat',
      name: '',
      text: '',
      messages: [],
      socket: null,
      //
      notificationState: false,
      notificationLoader: false,
      notificationData: [],
      publicPath: process.env.BASE_URL,
    }
  },

  methods: {

    clickButton: function (data) {
      // $socket is socket.io-client instance

      this.$socket.emit('msgToServer', data)
    },
    sendMessage () {

      const message = {
        name: this.name,
        text: this.text,
      }
      //this.socket.emit('msgToServer', message)
      this.text = ''
    },

    receivedMessage (message) {
      this.messages.push(message)
      alert(message)
    },

    async toggleNotification () {
      this.notificationState = !this.notificationState
      if (this.notificationLoader) {
        this.notificationLoader = false
        this.notificationData = null
      }
      else {
        this.notificationData = await LoadEvents.getNotificationsData()

        this.notificationLoader = true
        console.log(this.notificationData)
      }

    },

    getUnique (arr, comp) {

      // store the comparison  values in array
      return arr.map(e => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e]).map(e => arr[e])
    },

  },

  computed: {
    ...mapGetters({
      user: 'user/get',
    }),
  },

}

</script>

<style lang="scss" scoped>
.wrapper__profile {
  display: flex;
  position: relative;
}


.profile {
  min-width: 167px;
  //margin-left: 40px;
  height: 57px;
  padding: 0 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #ffffff;
  background: linear-gradient(90.17deg, rgba(33, 30, 33, 0.4) 34.95%, rgba(71, 65, 70, 0.4) 99.88%), #443B44;
  border-radius: 10px;

  &__notification {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__notification-list {
    position: absolute;
    left: -100px;
    top: 80px;
    z-index: 20;
    height: 100%;
    width: 300px;
  }

  &__notification-loader {
    background: #443B44;
    height: 100px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
  }

  &__notification-image {
    width: 40px;
    height: 40px;

    img {

      border-radius: 50%;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__notification-elem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 6px 6px 6px 6px;
    border-bottom: solid 2px #282527;
    background: linear-gradient(90.17deg, rgba(33, 30, 33, 0.4) 34.95%, rgba(71, 65, 70, 0.4) 99.88%), #443B44;
    height: 100%;
    box-sizing: unset;

    &:first-of-type {
      border-radius: 6px 6px 0 0;

    }

    &:last-of-type {
      border-radius: 0 0 6px 6px;
      border-bottom: unset;
    }

  }

  &__notification-record {
    margin-left: 10px;
  }

  &__notification-text {
    font-size: 14px;
    position: absolute;
    top: 8px;
    right: -10px;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    text-align: center;
    background: linear-gradient(91.75deg, #DFB666 -16.43%, #AA7E4A 86.42%);
    box-shadow: 0px 0px 14px rgba(180, 144, 85, 0.6);

  }

  &__avatar {
    height: 40px;
    width: 40px;

  }

  &__name {
    padding: 0 14px;
    color: #fff;
  }

  &__arrpw {

  }

}
</style>
